"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactNativeToastNotifications = _interopRequireDefault(require("react-native-toast-notifications"));

var _ToastMessageComponent = _interopRequireDefault(require("./ToastMessage-component"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Toast = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(_reactNativeToastNotifications.default, {
  ref: ref,
  placement: "top",
  animationType: "slide-in",
  animationDuration: 400,
  renderToast: options => {
    return /*#__PURE__*/_react.default.createElement(_ToastMessageComponent.default, {
      message: options.message,
      options: {
        actionText: options.data?.actionText,
        action: options.data?.action,
        type: options.data?.type,
        showDismiss: options.data?.showDismiss
      }
    });
  }
}, props.children));

var _default = Toast;
exports.default = _default;